import { render, staticRenderFns } from "./sumlist.vue?vue&type=template&id=52988b92&scoped=true"
import script from "./sumlist.vue?vue&type=script&lang=js"
export * from "./sumlist.vue?vue&type=script&lang=js"
import style0 from "./sumlist.vue?vue&type=style&index=0&id=52988b92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52988b92",
  null
  
)

export default component.exports